import { Feather } from '@expo/vector-icons';
import { Checkbox as TamaguiCheckbox, useTheme } from 'tamagui';

interface CheckboxProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  ariaLabel?: string;
  disabled?: boolean;
}

/**
 * Custom checkbox component with Feather icon indicator
 */
export const Checkbox = ({
  checked,
  onCheckedChange,
  ariaLabel,
  disabled = false,
}: CheckboxProps): React.ReactElement => {
  const theme = useTheme();

  return (
    <TamaguiCheckbox
      checked={checked}
      onCheckedChange={(value) => onCheckedChange?.(value === true)}
      aria-label={ariaLabel}
      disabled={disabled}
      borderRadius="$true"
    >
      <TamaguiCheckbox.Indicator>
        <Feather name="check" size={16} color={theme.color.val} />
      </TamaguiCheckbox.Indicator>
    </TamaguiCheckbox>
  );
};
